import { render } from "./recruitment-stage.vue?vue&type=template&id=53fa51c6&ts=true"
import script from "./recruitment-stage.ts?vue&type=script&lang=ts&external"
export * from "./recruitment-stage.ts?vue&type=script&lang=ts&external"

import "./recruitment-stage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__